import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleDetail from "../pages/article/ArticleDetail";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mulebuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/:slug",
    element: <ArticleDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;